import { createFileRoute } from "@tanstack/react-router";
import { loadLegacyContent, LegacyContent, legacyHead } from "@/lib/legacy-content";

export const Route = createFileRoute("/orthopaedics-surgeries/$slug")({
  loader: ({ params }) => loadLegacyContent(`orthopaedics-surgeries/${params.slug}`),
  head: ({ loaderData, params }) =>
    loaderData
      ? legacyHead(`/orthopaedics-surgeries/${params.slug}`, loaderData)
      : { meta: [{ title: "Orthopaedics Surgery — Healic" }] },
  component: () => <LegacyContent payload={Route.useLoaderData()} />,
});
